<div class="main-content">
    <div class="container-fluid">
        <div class="justify-content-center row">
            <div class="col-12">
                <div class="header">
                    <div class="header-body">
                        <div class="align-items-center row">
                            <div class="col">
                                <h6 class="header-pretitle">Overview</h6>
                                <h1 class="header-title text-truncate">Organisations</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <app-overview [query]="query" (dataChange)="data = $event" [windowScroll]="true">
                    <div class="header-bar align-items-center row mb-4">
                        <div class="col">
                            <app-filter [(filterTerm)]="term" (onUpdate)="executeQuery()" placeholder="Search"></app-filter>
                        </div>
                        <div class="col-auto ms-auto d-flex flex-row align-items-center">
                            <button *ngIf="appContext.isAdminOrIntermediary()" (click)="addOrganisation()" type="button" class="btn btn-primary">
                                <i class="bi bi-plus me-md-2"></i>
                                <span class="d-none d-md-inline">Add organisation</span>
                            </button>
                        </div>
                    </div>
                    <div class="overview-items pb-4">
                        <div class="row mx-0">
                            <ng-container *ngFor="let record of data; trackBy: trackByForRecord">
                                <div class="col-xl-4 col-md-6 col-12">
                                    <app-organisation-overview-item class="h-100 d-flex"
                                                                    [organisation]="record"></app-organisation-overview-item>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
                        <span class="h1 mb-2">No organisations found</span>
                        <span class="text-secondary">Try adjusting your filters or search term</span>
                    </div>
                </app-overview>
            </div>
        </div>
    </div>
</div>